import axios from 'axios';
import { API_HOST, API_HOST_V1 } from '../constants/constants';

export const getAssessmentState = async (token, userID, partnerID) => {
  const apiURL = `${API_HOST_V1}/workflows/current_state?cb=${new Date().getTime()}`;
  // todo - switch back to API_HOST v3 stuff?
  try {
    if (!userID || !token || !partnerID) {
      return false;
    }
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
        'x-dqpn-partner-id': partnerID,
        'Content-Type': 'application/json',
      },
    });

    // console.log('here is the data from getSession: ', data);
    return data;
  } catch (error) {
    console.error('Error fetching session data:', error);
    return null;
  }
};
